import {
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  createSlice,
} from '@reduxjs/toolkit'

const CreateGenericSlice = <T, Reducers extends SliceCaseReducers<T>>({
  name = '',
  initialState,
  reducers,
}: {
  name: string
  initialState: T
  reducers: ValidateSliceCaseReducers<T, Reducers>
}) => {
  return createSlice({
    name: name,
    initialState: initialState,
    reducers: reducers,
  })
}

const CreateGenericArraySlice = <
  T,
  Reducers extends SliceCaseReducers<Array<T>>
>({
  name = '',
  initialState,
  reducers,
}: {
  name: string
  initialState: Array<T>
  reducers: ValidateSliceCaseReducers<Array<T>, Reducers>
}) => {
  return createSlice({
    name: name,
    initialState: initialState,
    reducers: reducers,
  })
}
export { CreateGenericArraySlice }
export default CreateGenericSlice
